import { useMemo } from "react";
import useInvites from "../../hooks/useInvites";
import useCollapsibles from "../../hooks/useCollapsibles";
import Cards from "../Cards/Cards";
import { MdPeopleAlt } from "react-icons/md";
import CollapsibleBlock from "../CollapsibleBlock/CollapsibleBlock";
import { useTranslation } from "react-i18next";
import {
  DESKTOP_CARDS_NO_PANEL_PAGE_SIZE,
  DESKTOP_CARDS_PAGE_SIZE,
  MOBILE_CARDS_PAGE_SIZE,
} from "src/helpers/constants";
import clsx from "clsx";
import useMobile from "src/hooks/useMobile";
import { usePagination } from "src/hooks/usePagination";
import CardsPagination from "../Cards/CardsPagination";
import NoSentInvitesCta from "../Ctas/Contacts/NoSentInvitesCta";
import useUiPreferences from "src/store/useUiPreferences";
import { ICON_SIZES } from "src/constants/icons";

const SentInvitesList: React.FC = () => {
  const miscUiPreferences = useUiPreferences((s) => s.misc);

  const { isMobile } = useMobile();
  const { t } = useTranslation();
  const { collapsiblePreferences, updateCollapsible } = useCollapsibles();
  const { sentInvites, isLoadingInvites } = useInvites();
  const {
    items,
    canNext,
    next,
    prev,
    canPrev,
    totalPages,
    page,
    goTo,
    showPagination,
  } = usePagination(sentInvites, {
    pageSize: isMobile
      ? MOBILE_CARDS_PAGE_SIZE
      : miscUiPreferences.showDesktopRightPanel
        ? DESKTOP_CARDS_PAGE_SIZE
        : DESKTOP_CARDS_NO_PANEL_PAGE_SIZE,
  });

  const isLoadingSomething = useMemo(() => {
    return isLoadingInvites;
  }, [isLoadingInvites]);

  return (
    <CollapsibleBlock
      uppercase
      title={t("pages:contacts.collapsibles.sent.title")}
      badge={`${sentInvites?.length}`}
      open={collapsiblePreferences.contactsPageSentOpen}
      onChange={(isOpen: boolean) => {
        updateCollapsible({ contactsPageSentOpen: isOpen });
      }}
      icon={<MdPeopleAlt size={ICON_SIZES.SM} />}
    >
      {sentInvites?.length ? (
        <div className={clsx(["flex", "w-full", "gap-4", "flex-col"])}>
          <Cards
            columns={
              isMobile ? 1 : miscUiPreferences.showDesktopRightPanel ? 2 : 3
            }
          >
            {items?.map?.((invite: any, key: number) => (
              <Cards.SentContactInvite
                key={invite._id}
                user={invite.to}
                index={key}
                date={invite?.date}
                id={invite._id}
              />
            ))}
          </Cards>
          {showPagination && (
            <CardsPagination
              canNext={canNext}
              canPrev={canPrev}
              goTo={goTo}
              next={next}
              prev={prev}
              page={page}
              totalPages={totalPages}
              totalItems={sentInvites?.length}
              pageSize={
                isMobile
                  ? MOBILE_CARDS_PAGE_SIZE
                  : miscUiPreferences.showDesktopRightPanel
                    ? DESKTOP_CARDS_PAGE_SIZE
                    : DESKTOP_CARDS_NO_PANEL_PAGE_SIZE
              }
            />
          )}
        </div>
      ) : (
        <NoSentInvitesCta />
      )}
    </CollapsibleBlock>
  );
};

export default SentInvitesList;
